<template>
  <div class="book-reader">
    <Header />

    <button class="btn-back" @click="$router.go(-1)">
      Voltar
    </button>

    <iframe
      v-if="pdfUrl"
      :src="pdfUrl"
      width="100%"
      height="800px"
      frameborder="0"
    ></iframe>

    <div v-else-if="book.hash">
      Carregando livro...
    </div>

    <div v-else>
      Livro não encontrado.
    </div>

    <BookModal v-if="showModal" :book="book" @close="showModal = false" />
  </div>
</template>

<script>
import request, { Url } from '../router/request'
import Header from '@/components/Header.vue'
import BookModal from '@/components/BookModal.vue'
import '@/styles/Book.css'

export default {
  name: 'BookView',
  components: {
    Header,
    BookModal
  },
  data() {
    return {
      pdfUrl: '',
      showModal: false,
      book: {
        amd: this.$route.query.amd,
        hash: this.$route.query.hash
      }
    }
  },
  methods: {
    viewBook() {
      const { amd, hash } = this.book;

      if (!amd || !hash) {
        alert('Parâmetros ausentes para carregar o PDF.');
        return;
      }

      console.log('Preparando PDF com:', { amd, hash });

      request.post('/arquivo/prepararDownload', {
        ano_mes_dia_arq: amd,
        hash_arquivo: hash
      })
      .then(response => {
        console.log('Resposta prepararDownload:', response.data);
        if (response.data && response.data.hash) {
          this.pdfUrl = `${Url}/arquivo/download?hash=${response.data.hash}`;
        } else {
          alert('Erro: o PDF não foi preparado corretamente.');
        }
      })
      .catch(error => {
        console.error('Erro ao preparar o PDF:', error);
        alert('Erro ao preparar o PDF. Verifique os dados ou tente novamente.');
      });
    }
  },
  mounted() {
    console.log('URL da API:', Url);
    window.scrollTo(0, 0);
    this.viewBook();
  }
}
</script>

